/*
  Bonny & Rose funnel (2026-09-16): the ad sells one feeling, the line under the
  title confirms it. The ad link carries ?feel=<key>; the matching line from
  custom.sublines (JSON {key: line}) replaces the default subline. The choice
  stays for the tab, so switching colour or size keeps the feeling. No feel, no
  JSON, or an unknown key: nothing changes.
*/
(function () {
  'use strict';
  function apply() {
    var el = document.querySelector('.product-subline[data-br-sublines]');
    if (!el) return;
    var feel = null;
    try {
      feel = new URLSearchParams(location.search).get('feel');
      if (feel) sessionStorage.setItem('br-feel', feel);
      else feel = sessionStorage.getItem('br-feel');
    } catch (e) {}
    if (!feel) return;
    var list;
    try { list = JSON.parse(el.getAttribute('data-br-sublines') || '{}'); } catch (e) { return; }
    if (list && list[feel]) el.textContent = list[feel];
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', function () { window.setTimeout(apply, 0); });
})();
